import { BlockContentValue } from "@silversea-ssc/ui-components-react";
import { toPlainText } from "@portabletext/react";
import { BlockContentFragment } from "types/graphql-types";

export const blockContentToString = (
  blocks: BlockContentValue | BlockContentFragment[] | undefined
): string => {
  if (!blocks) return "";
  if (typeof blocks === "string") return blocks;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return toPlainText(blocks as any);
};
